import jiff from 'jiff';
import { DateTime } from "luxon";
import * as jsonpatch from 'fast-json-patch';
import siteService from "@services/siteService.js";
const replaceDataPath = (path, state) => {
  const lang = state.metadata.language
  const pageID = state.metadata.pageID
  return path.replace('/screen', `/languages/${lang}`)
    .replace('/metadata', '')
    .replace(`/languages/${lang}/pages/assets`, `/languages/${lang}/pages/${pageID}/assets`)
    .replace(`/languages/${lang}/pages/props`, `/languages/${lang}/pages/${pageID}/props`)
}

const revertDataPath = (path, state) => {
  const lang = state.metadata.language
  const pageID = state.metadata.pageID
  return path.replace(`/languages/${lang}`,'/screen' )
    .replace(`/screen/pages/${pageID}`,`/screen/pages`)
    .replace(`/languages/${lang}/pages/${pageID}/assets`,`/screen/pages/assets`)
    .replace(`/languages/${lang}/pages/${pageID}/props`,`/screen/pages/props`)
}

const state = {
  logs: [],
  temp: [],
  logsPathTimestamp:{},
  logsIndex: -1,
  snapshotSynce: [],
  metadataObserver: undefined,
  logTimeStamp: DateTime.now(),
  autoSaveTimeStamp: undefined,
  autoSaving: false,
  patchData: true,
  synceResponse: undefined,
  patchError: false,
  patchErrorObj: undefined,
  synceError: false,
  synceDiff: undefined,
  isOrdered : false,
  myInterval : undefined,
  tempLogs: undefined,
}

const getters = {
  autoSaveTimeStamp: state => {
    return state.autoSaveTimeStamp
  },
  autoSaving: state => {
    return state.autoSaving
  },
  synceResponse: state => {
    return state.synceResponse
  },
  synceError: state => {
    return state.synceError
  },
  patchError: state => {
    return state.patchError
  },
  synceDiff: state => {
    return state.synceDiff
  },
  logsIndex: state => {
    return state.logsIndex
  },
  canUndo: state => {
    return state.logsIndex >= 0
  },
  canRedo: state => {
    return state.logsIndex < state.logs.length - 1
  },
  snapshotSynce: state => {
    return state.snapshotSynce
  },
  logs: state => {
    return state.logs;
  },
  patchData: state => {
    return state.patchData;
  },
  tempLogs: state => {
    return state.tempLogs;
  },
  logsPathTimestamp : state => {
    return state.logsPathTimestamp
  }
}
const actions = {
  undo({ getters, commit, dispatch, state, rootState }) {

    if (getters.canUndo) {
      let snapshot = jiff.inverse(state.logs[state.logsIndex]);
      snapshot = snapshot.map(i => {return Object.assign({},{ ...i , time : Date.now()}) }).filter(i => i.op != 'test');

      dispatch("design/component/elActive", {}, { root: true });
      dispatch("designIframe/frame/resetFrame", {}, { root: true });

      setTimeout(() => {
        const domainDisplay = rootState.design.site.domains.main;
        let oldLog = JSON.parse(localStorage.getItem(`LOG_${domainDisplay}`));
        let oldLogNew = Object.keys(oldLog).filter(key => oldLog[key].status == '');
        if(oldLog && oldLogNew.length) {
          oldLogNew.map(key => {
            oldLog[key] = {...oldLog[key], ...{status : 'undo'}}
          }) 
        }
        localStorage.setItem(`LOG_${domainDisplay}`,JSON.stringify(oldLog));
      },100);

      dispatch('setTempLogs',snapshot);
      dispatch('commitDataChange', {
        payload: { snapshot: snapshot },
      });
      commit('UNDO', { snapshot: snapshot, force: true })
      commit('SET_LOGS_INDEX', state.logsIndex - 1)
    }
  },
  redo({ getters, commit, dispatch, state, rootState }) {
    if (getters.canRedo) {
      let snapshot = state.logs[state.logsIndex + 1];
      snapshot = snapshot.map(i => {return Object.assign({},{ ...i , time : Date.now()}) }).filter(i => i.op != 'test');

      dispatch("design/component/elActive", {}, { root: true });
      dispatch("designIframe/frame/resetFrame", {}, { root: true });
      
      dispatch('setTempLogs',snapshot);
      dispatch('commitDataChange', {
        payload: { snapshot: snapshot },
      });
      commit('REDO',{ snapshot })
      commit('SET_LOGS_INDEX', state.logsIndex + 1)

      setTimeout(() => {
        const domainDisplay = rootState.design.site.domains.main;
        let oldLog = JSON.parse(localStorage.getItem(`LOG_${domainDisplay}`));
        let oldLogNew = Object.keys(oldLog).filter(key => oldLog[key].status == '');
        if(oldLog && oldLogNew.length) {
          oldLogNew.map(key => {
            oldLog[key] = {...oldLog[key], ...{status : 'redo'}}
          }) 
        }
        localStorage.setItem(`LOG_${domainDisplay}`,JSON.stringify(oldLog));
      }, 100);
    }
  },
  genSnapshot({ state, dispatch, commit }) {
    dispatch("designIframe/frame/reRenderFrame", {} , { root : true });
    var diffList = jsonpatch.generate(state.metadataObserver, true)
    diffList = diffList.map(i => {return Object.assign({},{ ...i , time : Date.now()}) });
    const diffListWithoutTest = diffList.filter(i => i.op != 'test');
    if (diffList.length > 0) {
      if (this.state.design.mode == 'temporary') {
        commit('ADD_TEMP', { diffList })
        dispatch('design/postToChildren', { func: 'snapshot/activeSectionChangeParent', payload: { snapshot : diffListWithoutTest } }, { root: true });
      } else {
        if(state.logsIndex != state.logs.length - 1) {
          commit('CLEAR_LOGS' , state.logsIndex);
        }
        dispatch('setTempLogs',diffList);
        dispatch('addLog', { diffList })
        dispatch('commitDataChange', {
          payload: {
            snapshot: diffListWithoutTest
          },
        });
      }
    }
  },
  commitDataChange({ dispatch, commit, state }, { payload, sendToChild = true }) {
    commit('SET_PATH_TIME_STAMP',  payload.snapshot );

    if (sendToChild) {
      dispatch('design/postToChildren', { func: 'snapshot/activeSectionChangeParent', payload }, { root: true });
    }

    if(!state.isOrdered) {
      commit('SET_AUTO_SAVE_TIME_STAMP');
      commit('SET_IS_ORDERED', true)
      dispatch('synceTimer');
    }
  },
  synceTimer({ dispatch, state, commit }) {
    const myInterval = setInterval(() => {
      if((DateTime.now().diff(state.autoSaveTimeStamp).milliseconds > 10000 ) && !state.autoSaving) {
        dispatch('synceSnapshot', {});
      }
    }, 1000);
    commit('SET_INTERVAL', myInterval);
  },
  clearSnapshotInterval({ state }){
    clearInterval(state.myInterval);
  },
  async synceSnapshot({ commit, rootState, dispatch, state },{ manualSave = false }) {
    dispatch("designIframe/frame/reRenderFrame", {} , { root : true });
    let snapshot = []
    let snapshotTemp = jsonpatch.compare(rootState.design.original.metadataObserverOriginal.object , rootState.design.snapshot.metadataObserver.object)
    const timeElapsed = Date.now();
    const today = new Date(timeElapsed);

    snapshotTemp.forEach(item => {
      snapshot.push({
        ...item, path: replaceDataPath(item.path, rootState.design)
      });
    })
    let snapshotNoReplace = JSON.parse(JSON.stringify(snapshotTemp));

    if (snapshot.length > 0 && !state.autoSaving) {
      commit('SET_AUTO_SAVING', true);
      const domainDisplay = rootState.design.site.domains.main;
      let oldLog = JSON.parse(localStorage.getItem(`LOG_${domainDisplay}`));
      if(oldLog) {
        Object.keys(oldLog).map(key => {
          if(!oldLog[key].status && new Date(oldLog[key].date) <= today) {
            oldLog[key] = { ...oldLog[key] , ...{status : 'saving'}}
          }
        });
      }
      localStorage.setItem(`LOG_${domainDisplay}`,JSON.stringify(oldLog));

      await siteService.setSite({ data: { actions: snapshot, transactionID:  localStorage.getItem('lastTransactionID')} }).then((response) => { 
        commit('SET_SYNCE_ERROR', false)
        commit('SET_SYNCE_RESPONSE', response ? response : {})
        commit('SET_SYNCE_DIFF', (response && response.result && response.result.diffs) || undefined)
        commit('SET_AUTO_SAVING', false)
        commit('SET_AUTO_SAVE_TIME_STAMP')
        dispatch("designIframe/frame/reRenderFrame", {} , { root : true });
        commit('SET_PATCH_DATA',true);
        localStorage.setItem('lastTransactionID', response.transactionID)
        
        const domainDisplay = rootState.design.site.domains.main;
        let oldLog = JSON.parse(localStorage.getItem(`LOG_${domainDisplay}`));
        if(oldLog) {
          Object.keys(oldLog).map(key => {
            // && oldLog[key].date < date
            if(oldLog[key].status == 'saving') {
              oldLog[key] = { ...oldLog[key] , ...{status : 'saved'}}
            }
          });
        }
        localStorage.setItem(`LOG_${domainDisplay}`,JSON.stringify(oldLog));

        let tempDiff = [];
        if(response && response.result && response.result.diffs) {
          response.result.diffs.forEach(item => {
            tempDiff.push({
              ...item, path: revertDataPath(item.path, rootState.design)
            });
          })
        }
        jsonpatch.unobserve(rootState.design.metadata, state.metadataObserver);
        let observeBefore = undefined;
        try {
          // patch original with old snap.
          observeBefore = jsonpatch.applyPatch(rootState.design.original.metadataObserverOriginal.object,snapshotNoReplace).newDocument;
        } catch (error) {
          console.log(error);
          commit('SET_PATCH_ERROR', true)
          commit('SET_ERROR_PATCH', error)
        }

        // compare observeBefore with observe.
        const snapshotNew = jsonpatch.compare(observeBefore , rootState.design.snapshot.metadataObserver.object);
        let originalNew = undefined;
        try {
          // apply observeBefore with tempDiff.
          originalNew = jsonpatch.applyPatch(observeBefore,tempDiff).newDocument;
        } catch (error) {
          console.log(error);
          commit('SET_PATCH_ERROR', true)
          commit('SET_ERROR_PATCH', error)
        }
        // set original with tempDiff + old snap.
        rootState.design.original.metadataObserverOriginal.object = {...JSON.parse(JSON.stringify(originalNew))};
        let observeNew = undefined;
        try {
          // apply snapshot new to oriignalNew.
          observeNew = jsonpatch.applyPatch(originalNew,snapshotNew).newDocument;
        } catch (error) {
          console.log(error);
          commit('SET_PATCH_ERROR', true)
          commit('SET_ERROR_PATCH', error)
        }
        // compare observeNew with observe.
        let snapshotTemp = jsonpatch.compare(rootState.design.snapshot.metadataObserver.object,observeNew);
        try {
          // apply snapshotTemp to meta and child.
          rootState.design.metadata = jsonpatch.applyPatch(rootState.design.metadata, snapshotTemp).newDocument;
        } catch (error) {
          console.log(error);
          commit('SET_PATCH_ERROR', true)
          commit('SET_ERROR_PATCH', error)
        }
        state.metadataObserver = jsonpatch.observe(rootState.design.metadata);
        snapshotTemp = snapshotTemp.map(i => {return Object.assign({},{ ...i , time : Date.now()}) });
        commit('SET_PATH_TIME_STAMP',  snapshotTemp );
        dispatch('design/postToChildren', { func: 'snapshot/activeSectionChangeParent', payload: { snapshot: snapshotTemp } }, { root: true });
        commit('SET_PATCH_DATA',false);
        dispatch("designIframe/frame/reRenderFrame", {} , { root : true });
        return true;
      }).catch((e) => {
        commit('SET_SYNCE_ERROR', true)
        let objText = e.response ? e.response : {};
        if(e.toJSON().message === 'Network Error') {
          objText = {
            status : 'Network error',
            data : {
              message : window.navigator.onLine ? 'ERR_SERVER_PROBLEM' : "ERR_NETWORK"
            }
          };
        }
        commit('SET_SYNCE_RESPONSE', objText)
        commit('SET_SYNCE_DIFF', undefined)
        commit('SET_AUTO_SAVING', false)
        // commit('SET_AUTO_SAVE_TIME_STAMP')
        dispatch('design/original/setOriginalObserver', JSON.parse(JSON.stringify(rootState.design.snapshot.metadataObserver)), { root: true })
        dispatch("designIframe/frame/reRenderFrame", {} , { root : true });

        const domainDisplay = rootState.design.site.domains.main;
        let status = 'saved fail';
        if(['ERROR_DESIGN_JSON_NOT_UP_TO_DATE','ERROR_DESIGN_OTHER_USER_IS_USING'].includes(e.response.data.error) || e.toJSON().message === 'Network Error') {
          status = '';
        }

        let oldLog = JSON.parse(localStorage.getItem(`LOG_${domainDisplay}`));
        if(oldLog) {
          Object.keys(oldLog).map(key => {
            // && oldLog[key].date < date
            if(oldLog[key].status == 'saving') {
              oldLog[key] = { ...oldLog[key] , ...{status}}
            }
          });
        }
        localStorage.setItem(`LOG_${domainDisplay}`,JSON.stringify(oldLog));
      })
      return false;
    } else {
      // commit('SET_SYNCE_ERROR', false)
      // commit('SET_SYNCE_RESPONSE', {})
      // commit('SET_SYNCE_DIFF', undefined)
      if(manualSave) {
        commit('SET_AUTO_SAVING', true)
        setTimeout(() => {
          commit('SET_AUTO_SAVING', false)
        }, 200);
      }
      commit('SET_AUTO_SAVE_TIME_STAMP')
      dispatch('design/original/setOriginalObserver', JSON.parse(JSON.stringify(rootState.design.snapshot.metadataObserver)), { root: true })
      dispatch("designIframe/frame/reRenderFrame", {} , { root : true });
      return true;
    }
  },
  addLog({ commit }, { diffList }) {
    commit("addLog", {
      diffList
    });
    commit('SET_LOG_TIMESTAMP')
  },
  applyTemp({ dispatch, state, commit }) {
    let diffList = JSON.parse(JSON.stringify(state.temp));
    let snapshot = state.temp.map(i => {return Object.assign({},{ ...i , time : Date.now()}) }).filter(i => i.op != 'test');

    dispatch("design/setMode", {}, {root: true});
    if(diffList.length) {
      commit("addLog", { diffList });
      dispatch('setTempLogs',diffList);
    }
    dispatch('commitDataChange', {
      payload: { snapshot },
    });

    commit("APPLY_TEMP");
  },
  clearTemp({ commit, dispatch }) {
    let snapshot = jiff.inverse(state.temp);
    snapshot = snapshot.map(i => {return Object.assign({},{ ...i , time : Date.now()}) }).filter(i => i.op != 'test');
    dispatch('design/postToChildren', { func: 'snapshot/activeSectionChangeParent', payload: { snapshot: snapshot, type: 'clear' } }, { root: true });
    commit('CLEAR_TEMP',{ snapshot })

  },
  childSnapshot({ commit, dispatch, state, rootState }, { diffList, snapshot  }) {
    if (diffList.length > 0) {
      if (this.state.design.mode == 'temporary') {
        commit('ADD_TEMP', { diffList })
        jsonpatch.unobserve(rootState.design.metadata, state.metadataObserver)
        try {
          rootState.design.metadata = jsonpatch.applyPatch(rootState.design.metadata, snapshot).newDocument
        } catch (error) {
          console.log(error);
          commit('SET_PATCH_ERROR', true)
          commit('SET_ERROR_PATCH', error)
        }
        state.metadataObserver = jsonpatch.observe(rootState.design.metadata);
        
      } else {
        commit('SET_PATCH_DATA',true);
        let snapshotTemp = [];
        snapshot.map(item => {
          if(state.logsPathTimestamp && state.logsPathTimestamp[item.path]) {
            const oldObj = state.logsPathTimestamp[item.path];
            if(item.time > oldObj) {
              snapshotTemp.push(item);
            }
          }else {
            snapshotTemp.push(item);
          }
        });
        if(diffList.length) {
          dispatch('setTempLogs',diffList);
          commit("addLog", { diffList });
        }
        jsonpatch.unobserve(rootState.design.metadata, state.metadataObserver)
        try {
          rootState.design.metadata = jsonpatch.applyPatch(rootState.design.metadata, snapshotTemp).newDocument;
        } catch (error) {
          console.log(error);
          commit('SET_PATCH_ERROR', true)
          commit('SET_ERROR_PATCH', error)
        }
        state.metadataObserver = jsonpatch.observe(rootState.design.metadata);
        commit('SET_PATCH_DATA',false);
        dispatch('commitDataChange', {
          payload: { snapshot: snapshot },
          sendToChild: false
        });
      }
    }
  },
  addLogChildren({ commit }, { log }) {
    commit("addLog", { log });
  }, 
  patchErrorChildren({ commit }) {
    commit('SET_PATCH_ERROR', true)
  }, 
  clearDiff({ commit }) {
    commit('CLEAR_DIFF')
  },
  setTempLogs({commit,rootState},diffList) {
    if(diffList) {
      let snapshot = [];
      snapshot = diffList.filter(i => i.op != 'test').map(item => {
        return {...item, ...{path : replaceDataPath(item.path,rootState.design) , time : item.time || Date.now() }}
      });
      commit('SET_COMPARE_FOR_LOG',snapshot);
    }
  },
  mergelogs({rootState, dispatch,state}) {
    const domainDisplay = rootState.design.site.domains.main;
    const lang = rootState.design.metadata.language;
    const pageID = rootState.design.metadata.pageID;
    let oldLog = JSON.parse(localStorage.getItem(`LOG_${domainDisplay}`));
    let tempLogs = [];
    let logsCurrentUpdate = [];
    let logsOthersPage = [];
    let logsUpdateKey = [];

    if(oldLog) {
      Object.keys(oldLog).map(key => {
        if(oldLog[key].status != undefined && (oldLog[key].status == '' || oldLog[key].status == 'saving') ) {
          tempLogs.push(...oldLog[key].logs);
          logsUpdateKey.push(key);
        }
      });
    }

    if(tempLogs.length) {
      tempLogs.map(log => {
        if(log.path.includes(`/${lang}/`) || log.path.includes(`/${pageID}/`) || log.path.includes('/main/assets/')) {
          if(logsCurrentUpdate.findIndex(k => k.path == log.path && k.op == log.op) == -1){
            logsCurrentUpdate.push(log);
          }else if(logsCurrentUpdate.findIndex(k => k.path == log.path && k.op == log.op && log.time > k.time) != -1) {
            const index = logsCurrentUpdate.findIndex(k => k.path == log.path && k.op == log.op && log.time > k.time);
            logsCurrentUpdate[index] = log;
          }
        }else {
          if(logsOthersPage.findIndex(k => k.path == log.path && k.op == log.op ) == -1){
            logsOthersPage.push(log);
          }else if(logsOthersPage.findIndex(k => k.path == log.path && k.op == log.op && log.time > k.time) != -1) {
            const index = logsOthersPage.findIndex(k => k.path == log.path && k.op == log.op && log.time > k.time);
            logsOthersPage[index] = log;
          }
        }
      });
    }

    if(logsCurrentUpdate.length) {
      logsCurrentUpdate.map(item => {
          item.path = revertDataPath(item.path,rootState.design) 
          delete item.time;
      });
      jsonpatch.unobserve(rootState.design.metadata, state.metadataObserver)
      try {
        var errors = jsonpatch.validate(logsCurrentUpdate, rootState.design.metadata);
      
        if(errors) {
          Object.keys(logsCurrentUpdate).map(key => {
            if(oldLog[key].status != undefined && oldLog[key].status == '') {
              oldLog[key] = { ...oldLog[key] , ...{status : 'patch failed'}}
            }
          });
          localStorage.setItem(`LOG_${domainDisplay}`,JSON.stringify(oldLog));
        }else {
          rootState.design.metadata = jsonpatch.applyPatch(rootState.design.metadata, logsCurrentUpdate).newDocument;
          dispatch('commitDataChange', {
            payload: { snapshot: logsCurrentUpdate },
          });
        }
      } catch (e) {
        // commit('SET_PATCH_ERROR', true)
        // commit('SET_ERROR_PATCH', e)

        if(oldLog) {
          Object.keys(oldLog).map(key => {
            if(oldLog[key].status != undefined && oldLog[key].status == '') {
              oldLog[key] = { ...oldLog[key] , ...{status : 'patch failed'}}
            }
          });
        }
        localStorage.setItem(`LOG_${domainDisplay}`,JSON.stringify(oldLog));
      }
      state.metadataObserver = jsonpatch.observe(rootState.design.metadata);
    }

    if(logsOthersPage.length) {
      const timeElapsed = Date.now();
      const today = new Date(timeElapsed);

      const domainDisplay = rootState.design.site.domains.main;
      let oldLog = JSON.parse(localStorage.getItem(`LOG_${domainDisplay}`));
      if(oldLog) {
        Object.keys(logsOthersPage).map(key => {
          if(logsUpdateKey.indexOf(key) != -1) {
            oldLog[key] = { ...oldLog[key] , ...{status : 'saving'}}
          }
        });
      }
      localStorage.setItem(`LOG_${domainDisplay}`,JSON.stringify(oldLog));

      siteService.setSite({ data: { actions: logsOthersPage, transactionID:  localStorage.getItem('lastTransactionID')} }).then((response) => { 
        localStorage.setItem('lastTransactionID', response.transactionID);
        
        const domainDisplay = rootState.design.site.domains.main;
        let oldLog = JSON.parse(localStorage.getItem(`LOG_${domainDisplay}`));
        if(oldLog) {
          Object.keys(logsOthersPage).map(key => {
            if(oldLog[key].status == 'saving' && new Date(oldLog[key].date) <= today) {
              oldLog[key] = { ...oldLog[key] , ...{status : 'saved'}}
            }
          });
        }
        localStorage.setItem(`LOG_${domainDisplay}`,JSON.stringify(oldLog));

      }).catch((e) => {
        let status = 'saved fail';
        if(['ERROR_DESIGN_JSON_NOT_UP_TO_DATE','ERROR_DESIGN_OTHER_USER_IS_USING'].includes(e.response.data.error) || e.toJSON().message === 'Network Error') {
          status = '';
        }
        
        const domainDisplay = rootState.design.site.domains.main;
        let oldLog = JSON.parse(localStorage.getItem(`LOG_${domainDisplay}`));
        if(oldLog) {
          Object.keys(logsOthersPage).map(key => {
            if(oldLog[key].status == 'saving' && new Date(oldLog[key].date) <= today) {
              oldLog[key] = { ...oldLog[key] , ...{status}}
            }
          });
        }
        localStorage.setItem(`LOG_${domainDisplay}`,JSON.stringify(oldLog));
      });
    }
  }
}
const mutations = {
  SET_SYNCE_RESPONSE(state, value) {
    state.synceResponse = value
  },
  SET_SYNCE_ERROR(state, value) {
    state.synceError = value
  },
  SET_PATCH_ERROR(state, value) {
    state.patchError = value
  },
  SET_SYNCE_DIFF(state, value) {
    state.synceDiff = value
  },
  SET_LOGS_INDEX(state, next) {
    state.logsIndex = next
  },
  UNDO(state, { snapshot }) {
    jsonpatch.unobserve(this.state.design.metadata, state.metadataObserver)
    try {
      this.state.design.metadata = jsonpatch.applyPatch(this.state.design.metadata, snapshot).newDocument
    } catch (error) {
      console.log(error);
      state.patchError = true;
      state.patchErrorObj = error;
    }
    state.metadataObserver = jsonpatch.observe(this.state.design.metadata);
  },
  REDO(state,{snapshot}) {
    jsonpatch.unobserve(this.state.design.metadata, state.metadataObserver)
    try {
      this.state.design.metadata = jsonpatch.applyPatch(this.state.design.metadata, snapshot).newDocument
    } catch (error) {
      console.log(error);
      state.patchError = true;
      state.patchErrorObj = error;
    }
    state.metadataObserver = jsonpatch.observe(this.state.design.metadata);
  },
  SET_AUTO_SAVING(state, bool) {
    state.autoSaving = bool
  },
  SET_PATCH_DATA(state, bool) {
    state.patchData = bool
  },
  SET_IS_ORDERED(state, bool) {
    state.isOrdered = bool
  },
  SET_AUTO_SAVE_TIME_STAMP(state) {
    state.autoSaveTimeStamp = DateTime.now();
  },
  addLog(state, { diffList }) {
    state.logs = [...state.logs.slice(0, state.logsIndex + 1), diffList]
    state.logsIndex = state.logs.length - 1;
  },
  ADD_TEMP(state, { diffList }) {
    state.temp = [...state.temp, ...diffList]
  },
  ADD_SORT(state, { diffList }) {
    state.tempSort = [...state.tempSort, ...diffList]
  },
  CLEAR_TEMP(state,{ snapshot }) {
    jsonpatch.unobserve(this.state.design.metadata, state.metadataObserver)
    try {
      this.state.design.metadata = jsonpatch.applyPatch(this.state.design.metadata, snapshot).newDocument
    } catch (error) {
      console.log(error);
      state.patchError = true;
      state.patchErrorObj = error;
    }
    state.metadataObserver = jsonpatch.observe(this.state.design.metadata);

    state.temp = []
  },
  CLEAR_TEMP_CHILD(state , { size }) {
    state.tempSort = state.tempSort.slice(size);
  },
  APPLY_TEMP(state) {
    state.temp = []
  },
  addPrevLog(state, { diffList }) {
    state.logs[state.logs.length - 1] = [...state.logs[state.logs.length - 1], ...diffList]
  },
  RESET_LOGS(state) {
    state.logs = []
    state.logsIndex = -1
  },
  SET_LOG_TIMESTAMP(state) {
    state.logTimeStamp = DateTime.now();
  },
  CLEAR_LOGS(state, index) {
    state.logs.slice(0,index+1);
  },
  SET_PATH_TIME_STAMP(state, diff) {
    diff.map( item => 
      state.logsPathTimestamp[item.path] = item.time ? item.time : Date.now()
    );
  },
  SET_ERROR_PATCH(state,error) {
    state.patchErrorObj = error;
  },
  CLEAR_DIFF(state) {
    state.synceDiff = undefined;
  },
  SET_INTERVAL(state , myInterval) {
    state.myInterval = myInterval;
  },
  SET_COMPARE_FOR_LOG(state , diffList ) {
    state.tempLogs = diffList
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};